import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useRef } from 'react';
import {
  KEY_ENTER_COMMAND,
  COMMAND_PRIORITY_LOW,
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  $isRootNode,
} from 'lexical';

export default function BlockExitPlugin() {
  const [editor] = useLexicalComposerContext();

  const enterCount = useRef(0);
  const lastEnterTime = useRef(0);

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        const now = Date.now();

        if (now - lastEnterTime.current < 400) {
          enterCount.current++;
        } else {
          enterCount.current = 1;
        }

        lastEnterTime.current = now;

        // ONLY on double enter
        if (enterCount.current !== 2) return false;

        editor.update(() => {
          const selection = $getSelection();

          if (!$isRangeSelection(selection)) return;

          let node = selection.anchor.getNode();

          //  find top level block node
          while (node.getParent() && !$isRootNode(node.getParent())) {
            node = node.getParent();
          }

          // create new paragraph AFTER block
          const paragraph = $createParagraphNode();

          node.insertAfter(paragraph);

          // move cursor to new paragraph
          paragraph.select();

          // reset counter
          enterCount.current = 0;
        });

        return true;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
}